import styled, { css } from "styled-components"

import { Input as BaseInput } from "@/design/Input"

export const Card = styled.section`
  ${({ theme }) => {
    const { borders, colors, spaces } = theme

    return css`
      color: ${colors.content.fg};
      background-color: ${colors.content.bg};
      border-radius: ${borders.radius.standard};
      padding: ${spaces.large};
    `
  }}
`

export const H2 = styled.h2`
  ${({ theme }) => {
    const { fonts, spaces } = theme

    return css`
      margin-top: 0;
      margin-bottom: ${spaces.largeToBig};
      font-size: ${fonts.size.heading3};
      font-weight: ${fonts.weight.regular};
      text-align: center;
    `
  }}
`

export const Input = styled(BaseInput)`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      margin-top: ${spaces.largeToBig};
    `
  }}
`

export const Footer = styled.footer`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      display: flex;
      justify-content: space-between;
      margin-top: ${spaces.large};
    `
  }}
`

export const Loader = styled.span`
  ${({ theme, $small = false }) => {
    const { colors, borders } = theme
    const { small, normal } = theme.iconSizes

    return css`
      width: ${$small ? small : normal};
      height: ${$small ? small : normal};
      border: ${borders.size.thick} solid ${colors.standard.fg};
      border-bottom-color: transparent;
      border-radius: 50%;
      display: inline-block;
      box-sizing: border-box;
      animation: rotation 1s linear infinite;

      @keyframes rotation {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `
  }}
`
